
//   $(document).ready(function(){
//     $('.text-with-icons__button a').on('click', function(e){
//       e.preventDefault();
//       $('html, body').animate({
//         scrollTop: $('#shopify-section-template--25074261033257__join_form_TNttxf').offset().top - 50
//       }, 800);
//     });
//   });


// document.getElementById('fileUpload').addEventListener('change', async function(e) {
//   const file = e.target.files[0];
//   const formData = new FormData();
//   formData.append('file', file);

//   // Upload using Shopify file API endpoint
//   const res = await fetch('/upload', {
//     method: 'POST',
//     body: formData
//   });

//   const data = await res.json();
//   document.getElementById('fileUrl').value = data.files[0].url;
// });


// // trigger click

//   $('.collapsible-content.is-open-default').trigger('click');
  
  
  
//   // .each(function () {
//   //   const contentId = $(this).attr('id');
//   //   const $trigger = $('[aria-controls="' + contentId + '"]');

//   //   if ($trigger.length && $trigger.attr('aria-expanded') !== 'true') {
//   //     $trigger.trigger('click');
//   //   }
//   // });


document.addEventListener("DOMContentLoaded", function () {

  document.addEventListener("click", function(event) {

    const sampleBtn = event.target.closest("#order-sample-btn");
    if (!sampleBtn) return;

    event.preventDefault();
    event.stopPropagation();

    const sampleId = parseInt(sampleBtn.getAttribute("data-sample-variant-id"));
    const MAX_QTY = 3; // max per identical sample SKU

    if (sampleBtn.disabled) return;

    // 🔎 STEP 1: Get Current Cart
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const existingItem = cart.items.find(item => item.id === sampleId);

        // 🧠 If item already exists
        if (existingItem) {

          const newQty = existingItem.quantity + 1;

          // ❌ Stop if already reached max
          if (existingItem.quantity >= MAX_QTY) {

  // Find the message div
          const msg = document.querySelector('.Quantity-limit-message');

          if (msg) {
            msg.classList.add('show');

            // Optional: auto-hide after 3 sec
            setTimeout(() => {
              msg.classList.remove('show');
            }, 3000);
          }

          return;
        }


          // ✅ Update quantity instead of adding new line
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: existingItem.key, // IMPORTANT: use key, not variant id
              quantity: newQty
            })
          });

        }

        // ➕ If NOT in cart → add first time
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: sampleId,
            quantity: 1,
             properties: {
            "Type": "Sample Product"
          }
          })
        });

      })
      .then(r => r && r.json())
      .then((data) => {

        if (!data) return;

        // 🔄 Refresh cart drawer like theme
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: { product: data }
          })
        );

      })
      .catch(err => console.error(err));

  });

  
});

// Soft cap: intercept regular ATC / cart change for -sample SKUs (closes S2854 hole)
(function () {
  if (window.__sampleCartCapInstalled) return;
  window.__sampleCartCapInstalled = true;

  const SAMPLE_MAX = 3;

  function normalizeSku(sku) {
    if (!sku) return "";
    return String(sku).trim().replace(/^['\u2018\u2019]/, "");
  }
  function isSampleSku(sku) {
    return /-sample$/i.test(normalizeSku(sku));
  }
  function showLimit() {
    const msg = document.querySelector(".Quantity-limit-message");
    if (msg) {
      msg.classList.add("show");
      setTimeout(function () { msg.classList.remove("show"); }, 3000);
    }
  }

  function findVariantSkuOnPage(variantId) {
    const id = String(variantId);
    // Impulse: window.meta.product.variants
    try {
      const metaVariants = window.meta && window.meta.product && window.meta.product.variants;
      if (Array.isArray(metaVariants)) {
        const v = metaVariants.find(function (x) { return String(x.id) === id; });
        if (v && v.sku != null) return v.sku;
      }
    } catch (e) {}
    // Impulse + custom: product JSON scripts
    const scripts = document.querySelectorAll('script[type="application/json"]');
    for (const s of scripts) {
      try {
        const data = JSON.parse(s.textContent);
        const variants = data && (data.variants || (data.product && data.product.variants));
        if (Array.isArray(variants)) {
          const v = variants.find(function (x) { return String(x.id) === id; });
          if (v && v.sku != null) return v.sku;
        }
      } catch (e) {}
    }
    // Selected variant option elements sometimes carry sku
    const opt = document.querySelector('[data-variant-id="' + id + '"][data-sku], [value="' + id + '"][data-sku]');
    if (opt && opt.getAttribute("data-sku")) return opt.getAttribute("data-sku");
    return null;
  }

  async function skuForVariantId(variantId) {
    let sku = findVariantSkuOnPage(variantId);
    if (sku != null) return sku;
    // Fallback: cart line
    try {
      const cart = await fetch("/cart.js").then(function (r) { return r.json(); });
      const hit = (cart.items || []).find(function (i) { return String(i.id) === String(variantId) || String(i.variant_id) === String(variantId); });
      if (hit) return hit.sku;
    } catch (e) {}
    // Fallback: /products/{handle}.js (works off-PDP too when pathname is a product)
    try {
      if (/\/products\//.test(location.pathname)) {
        const pj = await fetch(location.pathname + ".js").then(function (r) { return r.ok ? r.json() : null; });
        if (pj && Array.isArray(pj.variants)) {
          const v = pj.variants.find(function (x) { return String(x.id) === String(variantId); });
          if (v && v.sku != null) return v.sku;
        }
      }
    } catch (e) {}
    return null;
  }

  function parseBody(init) {
    if (!init || init.body == null) return null;
    if (typeof init.body === "string") {
      try { return JSON.parse(init.body); } catch (e) {
        try {
          const params = new URLSearchParams(init.body);
          const obj = {};
          params.forEach(function (v, k) { obj[k] = v; });
          return obj;
        } catch (e2) { return null; }
      }
    }
    return null;
  }

  const origFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const isAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(url);
    const isChange = /\/cart\/change(?:\.js)?(?:\?|$)/.test(url);
    if (!isAdd && !isChange) {
      return origFetch.apply(this, arguments);
    }

    const body = parseBody(init || {});
    if (!body) return origFetch.apply(this, arguments);

    try {
      if (isChange) {
        const qty = parseInt(body.quantity, 10);
        if (!isNaN(qty) && qty > SAMPLE_MAX) {
          const cart = await fetch("/cart.js").then(function (r) { return r.json(); });
          const key = String(body.id || body.line || "");
          const item = (cart.items || []).find(function (i) {
            return String(i.key) === key || String(i.id) === key || String(i.variant_id) === key;
          });
          if (item && isSampleSku(item.sku)) {
            showLimit();
            // Cap instead of rejecting hard — still block >3
            const capped = Object.assign({}, init, {
              body: JSON.stringify(Object.assign({}, body, { quantity: SAMPLE_MAX }))
            });
            // If already at max and trying higher, short-circuit with fake ok + no-op change to current
            if (item.quantity >= SAMPLE_MAX && qty > SAMPLE_MAX) {
              showLimit();
              return new Response(JSON.stringify(cart), { status: 200, headers: { "Content-Type": "application/json" } });
            }
            return origFetch.call(this, input, capped);
          }
        }
      }

      if (isAdd) {
        // items[] array or single id/quantity
        const items = body.items || [{ id: body.id, quantity: body.quantity || 1 }];
        const cart = await fetch("/cart.js").then(function (r) { return r.json(); });
        for (const line of items) {
          const vid = line.id || line.variant_id;
          const addQty = parseInt(line.quantity, 10) || 1;
          const sku = await skuForVariantId(vid);
          const existing = (cart.items || []).find(function (i) {
            return String(i.id) === String(vid) || String(i.variant_id) === String(vid);
          });
          const existingQty = existing ? existing.quantity : 0;
          const skuKnown = sku != null && isSampleSku(sku);
          const existingIsSample = existing && isSampleSku(existing.sku);
          if (skuKnown || existingIsSample) {
            if (existingQty + addQty > SAMPLE_MAX) {
              showLimit();
              const allowed = Math.max(0, SAMPLE_MAX - existingQty);
              if (allowed <= 0) {
                return new Response(JSON.stringify({ status: 422, message: "Maximum 3 of this sample per order", description: "You can add only 3 of this sample SKU" }), {
                  status: 422,
                  headers: { "Content-Type": "application/json" }
                });
              }
              // rewrite qty
              if (body.items) {
                line.quantity = allowed;
                init = Object.assign({}, init, { body: JSON.stringify(body) });
              } else {
                init = Object.assign({}, init, { body: JSON.stringify(Object.assign({}, body, { quantity: allowed })) });
              }
            }
          }
        }
      }
    } catch (err) {
      console.error("sample cart cap", err);
    }

    const resp = await origFetch.call(this, input, init);
    // Post-add safety net (covers SKU lookup miss / race): if a sample line landed > max, snap to max.
    if (isAdd && resp && resp.ok) {
      try {
        const clone = resp.clone();
        const data = await clone.json();
        const lines = data.items ? data.items : (data.id ? [data] : []);
        for (const line of lines) {
          if (!line || !isSampleSku(line.sku)) continue;
          if (Number(line.quantity) > SAMPLE_MAX) {
            showLimit();
            const key = line.key || String(line.id);
            await origFetch.call(this, "/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: key, quantity: SAMPLE_MAX })
            });
          }
        }
      } catch (e) {}
    }
    return resp;
  };
})();
